import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { State } from "src/app/store";
import { actions as fromAccount } from "src/app/store/account-store/";
import { AgencyPageActions } from "src/app/store/agency-store/actions";
import { actions as fromClaim } from "src/app/store/claim-store/";
import { actions as fromPolicy } from "src/app/store/policy-store/";
import { actions as fromUser } from "src/app/store/user-store";
import {
  accountFactory,
  agencyFactory,
  policyFactory,
} from "src/app/store/user-store/factory";
import { UserApiService } from "./user-api.service";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class UserService {

  private profileLoaded = false;
  private inFlight?: Promise<boolean>;

  constructor(
    private store: Store<State>,
    private userService: UserApiService
  ) {}

  getAuthenticationMethodsStatus() {
    return this.userService.getAuthenticationMethodsStatus();
  }

  updateAuthenticationMethods(payload: {
    emailMethod: { id?: string; email: string; isRegistered?: boolean };
    mobilePhoneMethod: { id?: string; phoneNumber: string; isRegistered?: boolean };
  }) {
    return this.userService.updateAuthenticationMethods(payload);
  }

  changeEmail(params: { confirmEmail: string; email: string }): import('rxjs').Observable<{ success?: boolean; message?: string }> {
    return this.userService.changeEmail(params).pipe(
      tap((response) => {
        if (response && response.success) {
          this.store.dispatch(fromUser.setEmail({ email: params.email }));
        }
      })
    );
  }

  addAccountOrPolicy(params: {
    accountOrPolicyNumber: string;
    policyZipCode: string;
  }) {
    try {

    return this.userService.addAccountOrPolicy(params);
    } catch (error) {
      console.error('Error in addAccountOrPolicy:', error);
      throw error;
    }
  }

  clearProfile(callback: () => void) {
    this.store.dispatch(fromAccount.clearAccounts());
    this.store.dispatch(AgencyPageActions.clearAgencies());
    this.store.dispatch(fromClaim.clearClaims());
    this.store.dispatch(fromPolicy.clearPolicies());
    callback();
  }

  removePolicy(params: { policyNumber: string }) {

        try {

    return this.userService.removePolicy(params);
    } catch (error) {
      console.error('Error in removePolicy:', error);
      throw error;
    }
  }

  deleteProfile() {
    return this.userService.deleteProfile().pipe(
      tap((response: { success?: boolean; message?: string }) => {
        if (response && response.success) {
          this.store.dispatch(fromUser.clearUser());
          this.clearProfile(() => {});
        }
      })
    );
  }

async loadProfileAsync(refresh: boolean = false): Promise<boolean> {
  console.log('loadProfileAsync called from UserService');
  // // Already loaded in this session
  // if (this.profileLoaded) return true;

  // Coalesce concurrent callers
  if (this.inFlight) return this.inFlight;

  this.inFlight = (async () => {
    try {
      // If getProfileAsync returns an Observable, switch it to:
      // const profile = await firstValueFrom(this.userService.getProfile$());
      const profile = await this.userService.getProfileAsync();

      this.store.dispatch(fromAccount.setAccounts({
        accounts: accountFactory.createAccounts(profile),
      }));
      this.store.dispatch(AgencyPageActions.setAgencies({
        agencies: agencyFactory.createAgencies(profile),
      }));
      this.store.dispatch(fromPolicy.setPolicies({
        policies: policyFactory.createPolicies(profile),
      }));

      this.profileLoaded = true;
      return true;
    } catch (err: any) {
      // Optional: branch on status to drive UI
      // if (err?.status === 401) { /* kick off login/linking flow */ }
      // if (err?.status === 403) { /* show not-authorized */ }
      console.error('Error loading user profile:', err);
      return false;
    } finally {
      this.inFlight = undefined; // allow retry after failure
    }
  })();

  return this.inFlight;
}
}
